import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import OwnerMsg from '../components/OwnerMsg';
import HeroSectionSecondary from '../components/HeroSectionSecondary';
import testimonials from '../data/testimonialData';
import '../styles/testimonial.css';

const Testimonial = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const getFilteredTestimonials = () => {
    if (activeCategory === 'all') return testimonials;
    return testimonials.filter(review => review.categories.includes(activeCategory));
  };

  return (
    <div className="testimonial-page">
      <Navbar />

      {/* Hero Section */}
      <HeroSectionSecondary
        title="What Our Clients Say"
        subtitle="35 years of exceeding expectations in the Wood River Valley"
        button1Text="Request A Consultation"
        button1Link="mailto:info@allseasons.info"
        button2Text="View Gallery"
        button2Link="/gallery"
        image="/images/maintenance/HEROmaintenance1.jpeg"
      />

      {/* Owner's Message */}
      <OwnerMsg/>

      {/* Featured Video Testimonial */}
      {/* <section className="section bg-soft-stone video-section">
        <div className="section-inner text-center">
          <h2 className="section-title">See What Our Clients Have to Say</h2>
          <div className="video-container">
            <div className="video-placeholder">
              <img
                src="https://via.placeholder.com/800x450/6BAED6/FFFFFF?text=Video+Testimonial"
                alt="Video testimonial placeholder"
              />
              <button className="play-button">▶</button>
            </div>
            <div className="video-caption">
              <h3>The Anderson Family - Complete Property Transformation</h3>
              <p>Watch how we transformed their 5-acre property into a showcase estate</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Testimonial Filter and Grid */}
      <section className="section bg-white testimonials-section">
        <div className="section-inner">
          <h2 className="section-title text-center">Client Reviews by Service</h2>

          {/* Filter Buttons */}
          <div className="filter-buttons">
            <button
              className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
              onClick={() => setActiveCategory('all')}
            >
              All Reviews
            </button>
            <button
              className={`filter-btn ${activeCategory === 'landscape' ? 'active' : ''}`}
              onClick={() => setActiveCategory('landscape')}
            >
              Landscaping
            </button>
            <button
              className={`filter-btn ${activeCategory === 'trees' ? 'active' : ''}`}
              onClick={() => setActiveCategory('trees')}
            >
              Tree Services
            </button>
            <button
              className={`filter-btn ${activeCategory === 'snow' ? 'active' : ''}`}
              onClick={() => setActiveCategory('snow')}
            >
              Snow Removal
            </button>
            <button
              className={`filter-btn ${activeCategory === 'maintenance' ? 'active' : ''}`}
              onClick={() => setActiveCategory('maintenance')}
            >
              Maintenance
            </button>
          </div>

          {/* Testimonial Grid */}
          <div className="testimonial-grid">
            {getFilteredTestimonials().map((testimonial, index) => (
              <div key={index} className="testimonial-card" data-number={`0${index + 1}`.slice(-2)}>
                {testimonial.source && (
                  <div className="review-source-badge">{testimonial.source}</div>
                )}
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-footer">
                  <div className="client-info">
                    <h4>{testimonial.name}</h4>
                    {testimonial.title && testimonial.company && (
                      <p>{testimonial.title}, {testimonial.company}</p>
                    )}
                    <p>{testimonial.location}</p>
                  </div>
                  <div className="service-info">
                    <span className="service-tag">{testimonial.service}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Review CTA Section */}
          <div className="google-review-cta">
            <h3>Leave Us a Review</h3>
            <p>Share your experience with All Seasons on your preferred platform</p>

            <div className="review-buttons">
              {/* Google Review - Direct link to Google Maps listing */}
              <a
                href="https://www.google.com/maps/place/All+Seasons+Landscaping/@43.4185184,-114.2565264,17z/data=!4m8!3m7!1s0x54abd3839f0be4e5:0xca4b6f4f2aa23e02!8m2!3d43.4185184!4d-114.2565264!9m1!1b1!16s%2Fg%2F1tdvpgnq"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-cta review-btn"
              >
                <svg className="review-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
                Review on Google
              </a>

              {/* Facebook Review */}
              <a
                href="https://www.facebook.com/profile.php?id=61588567298492"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-cta review-btn"
              >
                <svg className="review-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                Review on Facebook
              </a>

              {/* Yelp Review */}
              <a
                href="https://www.yelp.com/writeareview/biz/all-seasons-landscaping-bellevue"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-cta review-btn"
              >
                <svg className="review-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                </svg>
                Review on Yelp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Before & After Showcase */}
      <section className="section bg-white before-after">
        <div className="section-inner">
          <h2 className="section-title text-center">Transformations That Speak Louder Than Words</h2>
          <div className="before-after-grid">
            <div className="ba-item">
              <div className="ba-images">
                <div className="ba-image before">
                  <img src="/images/projects/sageDemo.jpeg" alt="Residential project before" />
                  <span className="ba-label">Before</span>
                </div>
                <div className="ba-image after">
                  <img src="/images/projects/sageFinal.jpg" alt="Residential project completed" />
                  <span className="ba-label">After</span>
                </div>
              </div>
              <h3>Residential New-Build Landscaping</h3>
              <p>Two neighboring homes, one cohesive vision with custom stone, pavers, and plantings</p>
            </div>
            <div className="ba-item">
              <div className="ba-images">
                <div className="ba-image before">
                  <img src="/images/projects/BeforeIsland1.jpeg" alt="HOA roundabout before renovation" />
                  <span className="ba-label">Before</span>
                </div>
                <div className="ba-image after">
                  <img src="/images/projects/finishedIsland.JPG" alt="HOA roundabout completed" />
                  <span className="ba-label">After</span>
                </div>
              </div>
              <h3>HOA Landscape Renewal</h3>
              <p>Simplified, modern design with native grasses and low-maintenance beauty</p>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area Section */}
      <section className="service-area-section">
        <div className="section-inner">
          <h2 className="section-title">Trusted Throughout the Wood River Valley</h2>
          <p className="section-intro">
            Proudly serving the entire Wood River Valley and surrounding communities
          </p>

          <div className="service-area-content">
            <div className="service-area-map">
              <img
                src="/images/Valley.jpeg"
                alt="All Seasons service area covering Wood River Valley including Sun Valley, Ketchum, Hailey, and Bellevue"
              />
              {/* City Markers */}
              <div className="city-marker" style={{ top: '43%', left: '9.5%' }}>
                <div className="marker-dot" data-city="sun-valley"></div>
                <div className="marker-label">Sun Valley</div>
              </div>
              <div className="city-marker" style={{ top: '52%', left: '15.5%' }}>
                <div className="marker-dot" data-city="ketchum"></div>
                <div className="marker-label">Ketchum</div>
              </div>
              <div className="city-marker" style={{ top: '59.5%', left: '59%' }}>
                <div className="marker-dot" data-city="hailey"></div>
                <div className="marker-label">Hailey</div>
              </div>
              <div className="city-marker" style={{ top: '40%', left: '76.5%' }}>
                <div className="marker-dot" data-city="bellevue"></div>
                <div className="marker-label">Bellevue</div>
              </div>
              <div className="city-marker" style={{ top: '39.5%', left: '16.5%' }}>
                <div className="marker-dot" data-city="elkhorn"></div>
                <div className="marker-label">Elkhorn Village</div>
              </div>
            </div>

            <div className="service-area-info">
              <h3>Communities We Serve</h3>
              <ul className="communities-list">
                <li data-city="sun-valley"><span className="city-color-box"></span>Sun Valley</li>
                <li data-city="ketchum"><span className="city-color-box"></span>Ketchum</li>
                <li data-city="hailey"><span className="city-color-box"></span>Hailey</li>
                <li data-city="bellevue"><span className="city-color-box"></span>Bellevue</li>
                <li data-city="elkhorn"><span className="city-color-box"></span>Elkhorn Village</li>
                <li data-city="surrounding"><span className="city-color-box"></span>And surrounding areas</li>
              </ul>
              <p className="service-note">
                Covering the complete Wood River Valley from residential properties to large commercial developments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section bg-white bottom-ctas-section">
        <div className="section-inner">
          <div className="bottom-ctas">
            <div className="cta-box">
              <h3>Ready to Join Our Happy Customers?</h3>
              <p>
                Let's discuss how we can transform your property into something extraordinary.
              </p>
              <a
                className="btn-cta"
                href="mailto:info@allseasons.info"
                target="_blank"
                rel="noopener noreferrer"
              >
                Request Consultation
              </a>
            </div>
            <div className="cta-box">
              <h3>See Our Work</h3>
              <p>
                Explore hundreds of completed projects across the Wood River Valley.
              </p>
              <Link
                className="btn-primary"
                to="/gallery">
                Browse Gallery
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonial;